import React from "react";
import { TreeSelect, Select, Button } from "antd";
import { Close } from "assets/icons";
import { IVehicleStatusList } from "store/attendance/attendance-model";
import { IProcessesData, ISaleChannelData } from "store/lobby/lobby-model";
import { searchIdByDescriptionSelected, searchProcessesIdByDescriptionSelected } from "utils/functions";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "./styled/index.styled";

export interface IFilterOptions {
  allProcessesList: Array<IProcessesData>;
  salesChannelList: Array<ISaleChannelData>;
  vehicleStatusList: Array<IVehicleStatusList>;
  statusId: number;
  setStatusId: React.Dispatch<React.SetStateAction<number>>;
  processValue: Array<string>;
  setProcessValue: React.Dispatch<React.SetStateAction<Array<string>>>;
  salesChannelvalue: Array<string>;
  setSalesChannelValue: React.Dispatch<React.SetStateAction<Array<string>>>;
  attendanceChangeFilterOptionsValue: (...args) => void;
  attendanceFetchRegisterAsync: (...args) => void;
  attendanceFetchSummaryAsync: (...args) => void;
  attendanceChangeFieldValue: (...args) => void;
}
const FilterOptions = ({
  allProcessesList,
  salesChannelList,
  attendanceChangeFilterOptionsValue,
  attendanceFetchRegisterAsync,
  attendanceFetchSummaryAsync,
  statusId,
  setStatusId,
  processValue,
  setProcessValue,
  salesChannelvalue,
  setSalesChannelValue,
  attendanceChangeFieldValue,
  vehicleStatusList,
}: IFilterOptions): JSX.Element => {
  const { SHOW_PARENT } = TreeSelect;
  const SELECT_PROCESSES = useTranslation({ id: "select_processes" });
  const SELECT_SALES_CHANNEL = useTranslation({ id: "select_channels" });
  const PROCESSES = useTranslation({ id: "processes" });
  const CHANNEL = useTranslation({ id: "channel" });
  const STATUS = useTranslation({ id: "status" });

  const checkIfTheFiltersAreFilled = processValue.length > 0 || salesChannelvalue.length > 0 || statusId !== 0;

  const listProcessesData = (data) => {
    const processes = data.map((x) => {
      return {
        title: x.description,
        value: x.description,
        children: [],
      };
    });
    return processes;
  };

  const listSaleChannelData = (data) => {
    const saleChannel = data.map((x) => {
      return {
        title: x.description,
        value: x.description,
        children: [],
      };
    });
    return saleChannel;
  };

  const processProps = {
    treeData: listProcessesData(allProcessesList),
    value: processValue,
    onChange: (newValue: string[]) => setProcessValue(newValue),
    treeCheckable: true,
    showCheckedStrategy: SHOW_PARENT,
    placeholder: SELECT_PROCESSES,
    style: {
      width: "100%",
    },
  };

  const salesChannelProps = {
    treeData: listSaleChannelData(salesChannelList),
    value: salesChannelvalue,
    onChange: (newValue: string[]) => setSalesChannelValue(newValue),
    treeCheckable: true,
    showCheckedStrategy: SHOW_PARENT,
    placeholder: SELECT_SALES_CHANNEL,
    style: {
      width: "100%",
    },
  };

  const onFilterOptionsQuery = () => {
    const processId = searchProcessesIdByDescriptionSelected(processValue, allProcessesList);
    const saleChannelId = searchIdByDescriptionSelected(salesChannelvalue, salesChannelList);
    attendanceChangeFilterOptionsValue("processId", processId);
    attendanceChangeFilterOptionsValue("saleChannelId", saleChannelId);
    attendanceChangeFilterOptionsValue("status", statusId);
    attendanceChangeFieldValue("pageIndex", 1);
    attendanceFetchRegisterAsync();
    attendanceFetchSummaryAsync();
  };

  const onCleanFilters = () => {
    setStatusId(0);
    setProcessValue([]);
    setSalesChannelValue([]);
    attendanceChangeFilterOptionsValue("processId", []);
    attendanceChangeFilterOptionsValue("saleChannelId", []);
    attendanceChangeFilterOptionsValue("status", null);
    attendanceChangeFieldValue("pageIndex", 1);
    attendanceFetchRegisterAsync();
    attendanceFetchSummaryAsync();
  };

  return (
    <S.FilterOptionsContainer>
      <div>
        <S.Label>{PROCESSES}</S.Label>
        <TreeSelect key="process" style={S.SelectField} {...processProps} maxTagCount="responsive" allowClear />
      </div>
      <div>
        <S.Label>{CHANNEL}</S.Label>
        <TreeSelect key="saleChannel" style={S.SelectField} {...salesChannelProps} maxTagCount="responsive" allowClear />
      </div>
      <S.StatusFilter>
        <S.Label>{STATUS}</S.Label>
        <Select size="large" style={S.SelectField} defaultValue={statusId} onChange={setStatusId} value={statusId} data-testid="statusSelected">
          {vehicleStatusList?.map(({ description, id }, index) => (
            <Select.Option value={id} key={index}>
              {description}
            </Select.Option>
          ))}
        </Select>
      </S.StatusFilter>
      <S.ButtonsFilter>
        <Button size="large" onClick={onFilterOptionsQuery} className="secondaryButton" data-testid="confirmFilter">
          {useTranslation({ id: "filter" })}
        </Button>
        <Button size="large" className="tertiaryButton" onClick={onCleanFilters} disabled={!checkIfTheFiltersAreFilled} icon={<Close />} data-testid="cleanFilters">
          {useTranslation({ id: "clean" })}
        </Button>
      </S.ButtonsFilter>
    </S.FilterOptionsContainer>
  );
};

export default FilterOptions;
